import { PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { PreferredCommunicationEnum } from '@pkg/form/common'
import { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const PatientRelativeId = entityId('patientRelative')

export type PatientRelativeIdType = typeof PatientRelativeId.Type

export const PatientRelativeRelationSchema = PatientRelation.extend({
  id: PatientRelativeId.schema,
  firstName: z.string().nullish(),
  lastName: z.string().min(1),
  comment: z.string().nullish(),
  address: PostalAddressSchema.nullish(),
  contact: z
    .object({
      email: z.coerce.string().nullish(),
      phone: z.coerce.string().nullish(),
      mobile: z.coerce.string().nullish(),
      fax: z.coerce.string().nullish(),
      preferredCommunication: z.enum(PreferredCommunicationEnum.$.zodEnum()).nullish(),
    })
    .nullish(),
})
export type PatientRelativeRelation = z.infer<typeof PatientRelativeRelationSchema>
